import {
  DatePickerChangeEvent,
  DatePicker as KendoDatePicker,
  MultiViewCalendar,
} from '@progress/kendo-react-dateinputs';
import { IntlProvider, load } from '@progress/kendo-react-intl';
import { Popup } from '@progress/kendo-react-popup';
import weekData from 'cldr-core/supplemental/weekData.json';
import roCaGeneric from 'cldr-dates-full/main/ro/ca-generic.json';
import roDateFields from 'cldr-dates-full/main/ro/dateFields.json';
import { ValidationError } from '../../apps/benefit/models/Errors';
import roCaGregorian from '../assets/calendar/ro/ca-gregorian.json';
import ErrorViewer from './ErrorViewer';

load(roCaGregorian, roDateFields, roCaGeneric, weekData);

interface IDatePickerProps {
  controlClassName?: string;
  className?: string;
  name?: string;
  id?: string;
  value?: Date;
  minDate?: Date;
  maxDate?: Date;
  label?: string;
  title?: string;
  disabled?: boolean;
  mandatory?: boolean;
  helper?: string;
  onChange?: (value: Date | null) => void;
  errors?: ValidationError[];
  clearErrors?: () => void;
  showClearButton?: boolean;
}

const customCalendar = (calendarProps: any) => (
  <MultiViewCalendar
    {...calendarProps}
    views={1}
    className={`${
      calendarProps.className ?? ''
    } app-date-picker-calendar`.trim()}
  />
);

const customPopup = (popupProps: any) => (
  <Popup
    {...popupProps}
    popupClass={`${popupProps.popupClass ?? ''} app-date-picker-popup`.trim()}
  />
);

const DatePicker = (props: IDatePickerProps) => {
  const classNames = `control-group ${props.controlClassName ?? ''} ${
    props.errors ? 'control-error' : ''
  }`.trim();

  const internalOnChange = (e: DatePickerChangeEvent) => {
    if (props.errors?.length) {
      props.clearErrors?.();
    }
    props.onChange?.(e.value);
  };

  return (
    <div className={classNames}>
      <div className="control-content">
        {!!props.label && (
          <label htmlFor={props.id}>
            {props.label}
            {props.mandatory && <sup>*</sup>}
          </label>
        )}
        <div className="control-input">
          <IntlProvider locale="ro">
            <div className="date-picker-container">
              <KendoDatePicker
                className={props.className}
                name={props.name}
                id={props.id}
                title={props.title}
                value={props.value ?? null}
                min={props.minDate}
                max={props.maxDate}
                disabled={props.disabled}
                format="dd/MM/yyyy"
                calendar={customCalendar}
                popup={customPopup}
                onChange={internalOnChange}
              />
              {!!props.value && props.showClearButton && (
                <button
                  type="button"
                  className="date-picker-clear"
                  aria-label="Clear date"
                  onClick={() => {
                    props.onChange?.(null);
                  }}
                >
                  ×
                </button>
              )}
            </div>
          </IntlProvider>
        </div>
      </div>
      {!!props.helper && <div className="control-info">{props.helper}</div>}
      <ErrorViewer errors={props.errors} />
    </div>
  );
};

DatePicker.defaultProps = {
  disabled: false,
  showClearButton: false,
};

export default DatePicker;
